import { request } from "../../../config/helpers/axios-instance";

const UpdateQuotation = async (data, id) =>

    await request({
        url: `quotation/admin/id/` + id,
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        data: data

    })
export { UpdateQuotation };